/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.Header = void 0;

var react_1 = __importStar(require("react"));

var slugify_1 = __importDefault(require("slugify"));

var StyleUtils_1 = __importDefault(require("./utils/StyleUtils"));

var name = 'Header';
exports.name = name;

var Header = function Header(_ref) {
  var Frame = _ref.Frame,
      Image = _ref.Image,
      List = _ref.List,
      ListItem = _ref.ListItem,
      Link = _ref.Link,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.containerRef = react_1.createRef();
      return _this;
    }

    _createClass(_class, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        var onMount = this.props.onMount;

        if (onMount) {
          setTimeout(function () {
            return onMount(_this2.containerRef.current);
          });
        }
      }
    }, {
      key: "renderNav",
      value: function renderNav(classes, nav) {
        return nav.map(function (navItem) {
          var link = navItem.link,
              title = navItem.title;
          return react_1.default.createElement(ListItem, {
            className: ['Header__nav-item', "Header__nav-item-".concat(slugify_1.default(title)), classes === null || classes === void 0 ? void 0 : classes.navItem],
            key: title,
            style: styles === null || styles === void 0 ? void 0 : styles.navItem
          }, react_1.default.createElement(Link, {
            className: ['Header__nav-link', classes === null || classes === void 0 ? void 0 : classes.link],
            href: link,
            style: styles === null || styles === void 0 ? void 0 : styles.link
          }, title));
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            after = _this$props.after,
            before = _this$props.before,
            classes = _this$props.classes,
            forwardRef = _this$props.forwardRef,
            logo = _this$props.logo,
            _this$props$nav = _this$props.nav,
            nav = _this$props$nav === void 0 ? [] : _this$props$nav;
        return react_1.default.createElement(Frame, {
          className: ['Header__container', classes === null || classes === void 0 ? void 0 : classes.container],
          ref: forwardRef,
          style: styles === null || styles === void 0 ? void 0 : styles.container
        }, react_1.default.createElement(Image, {
          className: ['Header__logo', classes === null || classes === void 0 ? void 0 : classes.logo],
          src: logo,
          style: styles === null || styles === void 0 ? void 0 : styles.logo
        }), react_1.default.createElement(List, {
          className: ['Header__nav', classes === null || classes === void 0 ? void 0 : classes.nav],
          style: styles === null || styles === void 0 ? void 0 : styles.nav
        }, before, this.renderNav(classes, nav), after));
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.Header = Header;

var style = function style(theme) {
  var _a, _b, _c, _d, _e, _f, _g;

  return {
    container: Object.assign({
      display: 'flex',
      height: (_a = theme.Header) === null || _a === void 0 ? void 0 : _a.height,
      justifyContent: 'space-between',
      maxWidth: (_b = theme.Body) === null || _b === void 0 ? void 0 : _b.maxWidth,
      '@web': {
        margin: '0 auto'
      }
    }, (_c = theme === null || theme === void 0 ? void 0 : theme.Header) === null || _c === void 0 ? void 0 : _c.container),
    link: Object.assign({
      textDecoration: 'none',
      '@web': {
        color: 'inherit'
      }
    }, (_d = theme === null || theme === void 0 ? void 0 : theme.Header) === null || _d === void 0 ? void 0 : _d.link),
    logo: Object.assign({
      height: '100%',
      marginLeft: 15,
      maxWidth: 200
    }, (_e = theme === null || theme === void 0 ? void 0 : theme.Header) === null || _e === void 0 ? void 0 : _e.logo),
    nav: Object.assign({
      display: 'none',
      listStyleType: 'none',
      '@media (min-width: 961px)': {
        display: 'flex'
      }
    }, (_f = theme === null || theme === void 0 ? void 0 : theme.Header) === null || _f === void 0 ? void 0 : _f.nav),
    navItem: Object.assign(Object.assign(Object.assign({
      alignSelf: 'center',
      fontSize: 15,
      fontWeight: '500'
    }, StyleUtils_1.default.margin('0 15px')), {
      textTransform: 'uppercase'
    }), (_g = theme === null || theme === void 0 ? void 0 : theme.Header) === null || _g === void 0 ? void 0 : _g.navItem)
  };
};

exports.style = style;